import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Ubicación',
    href: '#ubicacion'
  }, {
    name: 'Agendar',
    href: 'https://wa.me/525554362239?text=Hola%20Valentina%20quiero%20agendar%20una%20cita%20en%20Mimate%20Studio',
    external: true
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-mimate-bg/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-51">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-52">
        <a href="#" className="flex items-center" data-id="element-53">
          <img src="https://cdn.magicpatterns.com/uploads/qmsajrr5P6VNoaJuJWNXPe/Captura_de_pantalla_2026-04-17_a_la(s)_6.21.35_p.m..png" alt="Mímate Studio Logo" className="h-16 md:h-20 object-contain rounded-full" data-id="element-54" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-55">
          {navLinks.map(link => <a key={link.name} href={link.href} {...(link as any).external ? {
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {}} className={`font-medium transition-colors hover:text-mimate-primary ${link.name === 'Agendar' ? 'bg-mimate-primary text-white px-5 py-2 rounded-full hover:bg-mimate-primary/90 hover:text-white' : 'text-mimate-text'}`} data-id="element-56">
              {link.name}
            </a>)}
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-mimate-text" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-57">
          {isMobileMenuOpen ? <X size={28} data-id="element-58" /> : <Menu size={28} data-id="element-59" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-mimate-bg shadow-lg py-4 px-6 flex flex-col space-y-4 border-t border-mimate-primary/10" data-id="element-60">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} {...(link as any).external ? {
        target: '_blank',
        rel: 'noopener noreferrer'
      } : {}} className={`text-lg font-medium py-2 ${link.name === 'Agendar' ? 'bg-mimate-primary text-white text-center rounded-full mt-2' : 'text-mimate-text'}`} data-id="element-61">
              {link.name}
            </a>)}
        </div>}
    </header>;
}